import { render, staticRenderFns } from "./press-gallery.vue?vue&type=template&id=c9e5d6c8&"
import script from "./press-gallery.vue?vue&type=script&lang=js&"
export * from "./press-gallery.vue?vue&type=script&lang=js&"
import style0 from "./press-gallery.vue?vue&type=style&index=0&id=c9e5d6c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports